import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { getNormalizePathName, isNoIndexFollow } from "@/utils/common";
import { CDN_LINK, serverUrl } from "@globalConfig";
import { thumbUrl } from "@/utils/imagesHelpers";
import { getDateThreeMonthsFromNow, normalizePrice } from "@/utils/GlobalJavascriptFunction";
import { isAutosOrYearsOrNewCarsScreen, isAutosOrYearsScreen, isNewCarsPage } from "@/pages/search/searchHooks/filtersHelpers";
import { api__doSearch, api__doSearch_with_params } from "@/apis/search/search";
import { getAutosMakeModelAboutData, getFaqQuestions, getPageDescription } from "@/utils/AutosSEOPageDescription";
import CarPricesMakes from "@data/cars-prices-data/make.json";
import CarPricesModels from "@data/cars-prices-data/model.json";
import { api__getCarPriceDetails } from "@/apis/posts/getNewPostViewData";
var DEFAULT_AR_TITLE = "سيارات مستعملة للبيع في السعودية - سيارات جديدة: أفضل سعر | موقع سيارة";
var DEFAULT_EN_TITLE = "Used Cars for Sale in Saudi Arabia - New Cars: Best Prices | Syarah";
var DEFAULT_AR_OG_TITLE = "\u062A\u0635\u0641\u062D  \u0623\u0648\u0633\u0639 \u062A\u0634\u0643\u064A\u0644\u0629 \u0633\u064A\u0627\u0631\u0627\u062A \u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0645\u0636\u0645\u0648\u0646\u0629 \u0648\u062C\u062F\u064A\u062F\u0629 \u0641\u064A \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629 | \u0645\u0648\u0642\u0639 \u0633\u064A\u0627\u0631\u0629";
var DEFAULT_EN_OG_TITLE = "Browse the Widest Variety of Certified Used & New Cars in KSA | Syarah";
var DEFAULT_AR_OG_DESC = "\u062A\u0635\u0641\u062D \u062A\u0634\u0643\u064A\u0644\u0629 \u0645\u0646 \u0633\u064A\u0627\u0631\u0627\u062A\u0646\u0627 \u0627\u0644\u062C\u062F\u064A\u062F\u0629 \u0648\u0627\u0644\u0645\u0633\u062A\u0639\u0645\u0644\u0629 \u0627\u0644\u0645\u0636\u0645\u0648\u0646\u0629\u060C \u062E\u064A\u0627\u0631 \u062F\u0641\u0639 \u0628\u0627\u0644\u0643\u0627\u0634 \u0623\u0648 \u0628\u0627\u0644\u062A\u0642\u0633\u064A\u0637 \u2714 \u0628\u0623\u0641\u0636\u0644 \u0633\u0639\u0631\u2714 \u0646\u0648\u0635\u0644\u0647\u0627 \u0644\u0628\u064A\u062A\u0643 \u2714 \u0627\u0634\u062A\u0631\u0647\u0627 \u0645\u0646 \u0633\u064A\u0627\u0631\u0629 \u0627\u0644\u0622\u0646!";
var DEFAULT_EN_OG_DESC = "Browse a selection of new and used guaranteed cars, option to pay in cash or installments \u2714 best prices \u2714 doorstep delivery \u2714 buy it from Syarah now!";
var DEFAULT_AR_OG_IMG = CDN_LINK + "/assets/images/og/granted_ar.jpg";
var DEFAULT_EN_OG_IMG = CDN_LINK + "/assets/images/og/granted_en.jpg";
var DEFAULT_AR_PAGE = "الصفحة";
var DEFAULT_EN_PAGE = "Page";

/**
 * Fetches price table data for the search page based on selected make/model
 * Similar to data__table_data in carsPricesData.ts but uses static JSON imports
 */
export var getPricesTableData = function getPricesTableData(selectedOptions, language) {
  var _makeOption$name_en;
  if (!selectedOptions || selectedOptions.length === 0) {
    return null;
  }

  // Find make and model from selectedOptions
  var makeOption = selectedOptions.find(function (opt) {
    return opt.filterField === 'make_id';
  });
  var modelOption = selectedOptions.find(function (opt) {
    return opt.filterField === 'model_id';
  });
  if (!makeOption) {
    return null;
  }
  var makeSlug = (_makeOption$name_en = makeOption.name_en) === null || _makeOption$name_en === void 0 ? void 0 : _makeOption$name_en.toLowerCase().replace(/\s+/g, '-');

  // Helper function to process links (similar to CarPriceTableSection)
  var processLink = function processLink(link) {
    return link.includes("http") ? link.split('.com')[1] : link;
  };

  // If model is selected, try to get model-specific prices
  if (modelOption) {
    var _modelOption$name_en;
    var modelSlug = (_modelOption$name_en = modelOption.name_en) === null || _modelOption$name_en === void 0 ? void 0 : _modelOption$name_en.toLowerCase().replace(/\s+/g, '-');
    var modelKey = "".concat(makeSlug, "/").concat(modelSlug);
    var modelData = CarPricesModels[modelKey];
    if (modelData && modelData[language]) {
      var data = modelData[language];
      return data.map(function (row) {
        return _objectSpread(_objectSpread({}, row), {}, {
          link: processLink(row.link)
        });
      });
    }
    return null;
  }

  // Fallback to make-level prices
  var makeData = CarPricesMakes[makeSlug];
  if (makeData && makeData[language]) {
    var _data = makeData[language];
    return _data.map(function (row) {
      return _objectSpread(_objectSpread({}, row), {}, {
        link: processLink(row.link)
      });
    });
  }
  return null;
};

/**
 * Fetches financing data for the cheapest car in search results
 * Similar to how financing page fetches data for make/model
 */
export var getFinancingData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(req, posts) {
    var cheapestCar, financingData, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // Get the first (cheapest) car from search results
          cheapestCar = posts === null || posts === void 0 ? void 0 : posts[0];
          if (cheapestCar !== null && cheapestCar !== void 0 && cheapestCar.id) {
            _context.n = 1;
            break;
          }
          return _context.a(2, null);
        case 1:
          _context.p = 1;
          _context.n = 2;
          return api__getCarPriceDetails(req, cheapestCar.id);
        case 2:
          financingData = _context.v;
          return _context.a(2, financingData);
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error('Failed to fetch financing data:', _t);
          return _context.a(2, null);
      }
    }, _callee, null, [[1, 3]]);
  }));
  return function getFinancingData(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var extractDealId = function extractDealId(req) {
  var deal = req.query.deal || req.query.deal_id;
  if (!deal) {
    // if no deal in the query string, then try to match path /deal/:dealId
    // if yes, extract the dealId from the path
    var path = req.path;
    var dealPath = path.match(/\/deal\/(\d+)/);
    deal = dealPath ? dealPath[1] : null;
  }
  return deal;
};
export var generatePreloadImagesFromSearchApi = function generatePreloadImagesFromSearchApi(fullPageData) {
  var _ref2, _ref3;
  // Preload Images
  var preloadImages = [];
  // Preload Search first image

  (_ref2 = ["0x99", "0x154"]) === null || _ref2 === void 0 ? void 0 : _ref2.forEach(function (size) {
    var _fullPageData$marketi;
    preloadImages.push({
      device: "mobile",
      link: thumbUrl(fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$marketi = fullPageData.marketingBanner) === null || _fullPageData$marketi === void 0 ? void 0 : _fullPageData$marketi.mobile, "hero-v1", size, true)
    });
  });
  (_ref3 = ["0x99", "0x426"]) === null || _ref3 === void 0 ? void 0 : _ref3.forEach(function (size) {
    var _fullPageData$posts, _fullPageData$posts$, _fullPageData$similar, _fullPageData$similar2;
    preloadImages.push({
      device: "mobile",
      link: thumbUrl((fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$posts = fullPageData.posts) === null || _fullPageData$posts === void 0 ? void 0 : (_fullPageData$posts$ = _fullPageData$posts[0]) === null || _fullPageData$posts$ === void 0 ? void 0 : _fullPageData$posts$.image_url) || (fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$similar = fullPageData.similarItems) === null || _fullPageData$similar === void 0 ? void 0 : (_fullPageData$similar2 = _fullPageData$similar[0]) === null || _fullPageData$similar2 === void 0 ? void 0 : _fullPageData$similar2.image_url), "online-v1", size)
    });
  });
  ["0x154", "0x960"].forEach(function (size) {
    var _fullPageData$marketi2;
    preloadImages.push({
      device: "desktop_large",
      link: thumbUrl(fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$marketi2 = fullPageData.marketingBanner) === null || _fullPageData$marketi2 === void 0 ? void 0 : _fullPageData$marketi2.desktop, "hero-v1", size, true)
    });
  });
  ["0x154", "0x426"].forEach(function (size) {
    var _fullPageData$posts2;
    fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$posts2 = fullPageData.posts) === null || _fullPageData$posts2 === void 0 ? void 0 : _fullPageData$posts2.slice(0, 4).forEach(function (post) {
      preloadImages.push({
        device: "desktop_large",
        link: thumbUrl(post === null || post === void 0 ? void 0 : post.image_url, "online-v1", size)
      });
    });
  });
  return preloadImages;
};
export var seoData__search = function seoData__search(_ref4) {
  var fullPageData = _ref4.fullPageData,
    req = _ref4.req;
  if (!req.url.includes("/autos") && !req.url.includes("/years")) {
    return {
      robots: "noindex, follow"
    };
  }
  return {
    preloadImages_USE_THIS_ONLY: generatePreloadImagesFromSearchApi(fullPageData),
    canonical: "auto"
  };
};
export var newSearchFullPageData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref5) {
    var _getNormalizePathName;
    var req, normalizePathName, deal, dealParam, fullPageData, _getPageDescription, pageDescription1, pageDescription2, seoAboutData, pricesTableData, financingData, faqQuestions;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          req = _ref5.req;
          if (isAutosOrYearsOrNewCarsScreen({
            pathname: req.url
          })) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2);
        case 1:
          normalizePathName = ((_getNormalizePathName = getNormalizePathName(req.url).split('?')) === null || _getNormalizePathName === void 0 ? void 0 : _getNormalizePathName[0]) || "";
          deal = extractDealId(req);
          dealParam = deal ? "?deal=".concat(deal) : "";
          _context2.n = 2;
          return api__doSearch_with_params({
            req: req,
            page: req.query.page || 1,
            sort: "",
            size: 12,
            filters: {},
            link: "/" + normalizePathName + dealParam,
            includes: ["meta_tags", "seo_data", "quality_section"]
          });
        case 2:
          fullPageData = _context2.v;
          _getPageDescription = getPageDescription(req === null || req === void 0 ? void 0 : req.language, req === null || req === void 0 ? void 0 : req.url, fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.selectedOptions), pageDescription1 = _getPageDescription.pageDescription1, pageDescription2 = _getPageDescription.pageDescription2;
          seoAboutData = getAutosMakeModelAboutData(req === null || req === void 0 ? void 0 : req.url, fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.selectedOptions);
          pricesTableData = getPricesTableData(fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.selectedOptions, req === null || req === void 0 ? void 0 : req.language);
          _context2.n = 3;
          return getFinancingData(req, fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.posts);
        case 3:
          financingData = _context2.v;
          faqQuestions = getFaqQuestions(seoAboutData, fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.selectedOptions);
          return _context2.a(2, _objectSpread(_objectSpread({}, fullPageData), {}, {
            pageDescription1: pageDescription1,
            pageDescription2: pageDescription2,
            seoAboutData: seoAboutData,
            pricesTableData: pricesTableData,
            financingData: financingData,
            faqQuestions: faqQuestions
          }));
      }
    }, _callee2);
  }));
  return function newSearchFullPageData(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
export var autosFullPageData = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref7) {
    var _getNormalizePathName2;
    var req, normalizePathName, mainParams, usedCarsUnder30KParams, chineseUsedCarsParams, _yield$Promise$all, _yield$Promise$all2, _mainSearchData, usedCarsUnder30KData, chineseUsedCars, _getPageDescription2, _pageDescription, _pageDescription2, _seoAboutData, _pricesTableData, _financingData, _faqQuestions, mainSearchData, _getPageDescription3, pageDescription1, pageDescription2, seoAboutData, pricesTableData, financingData, faqQuestions, _t2;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.p = _context3.n) {
        case 0:
          req = _ref7.req;
          normalizePathName = ((_getNormalizePathName2 = getNormalizePathName(req.url).split("?")) === null || _getNormalizePathName2 === void 0 ? void 0 : _getNormalizePathName2[0]) || ""; // Prepare base request config
          mainParams = {
            req: req,
            page: req.query.page || 1,
            sort: "",
            size: 12,
            filters: {},
            link: "/" + normalizePathName,
            includes: ["meta_tags", "seo_data", "quality_section"]
          }; // If this is the used-cars page, fetch all in parallel
          if (!normalizePathName.includes("autos/used-cars")) {
            _context3.n = 6;
            break;
          }
          _context3.p = 1;
          usedCarsUnder30KParams = {
            filters: {
              condition_id: "0",
              sellingprice_from: "2000",
              sellingprice_to: "30000"
            },
            page: 1,
            size: 4
          };
          chineseUsedCarsParams = {
            filters: {
              condition_id: "0",
              make_country: "1"
            },
            page: 1,
            size: 4
          }; // Run all three APIs concurrently
          _context3.n = 2;
          return Promise.all([api__doSearch_with_params(mainParams), api__doSearch(req, 1, usedCarsUnder30KParams, []), api__doSearch(req, 1, chineseUsedCarsParams, [])]);
        case 2:
          _yield$Promise$all = _context3.v;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
          _mainSearchData = _yield$Promise$all2[0];
          usedCarsUnder30KData = _yield$Promise$all2[1];
          chineseUsedCars = _yield$Promise$all2[2];
          _getPageDescription2 = getPageDescription(req === null || req === void 0 ? void 0 : req.language, req === null || req === void 0 ? void 0 : req.url, _mainSearchData === null || _mainSearchData === void 0 ? void 0 : _mainSearchData.selectedOptions), _pageDescription = _getPageDescription2.pageDescription1, _pageDescription2 = _getPageDescription2.pageDescription2;
          _seoAboutData = getAutosMakeModelAboutData(req === null || req === void 0 ? void 0 : req.url, _mainSearchData === null || _mainSearchData === void 0 ? void 0 : _mainSearchData.selectedOptions);
          _pricesTableData = getPricesTableData(_mainSearchData === null || _mainSearchData === void 0 ? void 0 : _mainSearchData.selectedOptions, req === null || req === void 0 ? void 0 : req.language);
          _context3.n = 3;
          return getFinancingData(req, _mainSearchData === null || _mainSearchData === void 0 ? void 0 : _mainSearchData.posts);
        case 3:
          _financingData = _context3.v;
          _faqQuestions = getFaqQuestions(_seoAboutData, _mainSearchData === null || _mainSearchData === void 0 ? void 0 : _mainSearchData.selectedOptions);
          return _context3.a(2, _objectSpread(_objectSpread({}, _mainSearchData), {}, {
            usedCarsUnder30K: (usedCarsUnder30KData === null || usedCarsUnder30KData === void 0 ? void 0 : usedCarsUnder30KData.products) || [],
            chineseUsedCars: (chineseUsedCars === null || chineseUsedCars === void 0 ? void 0 : chineseUsedCars.products) || [],
            pageDescription1: _pageDescription,
            pageDescription2: _pageDescription2,
            seoAboutData: _seoAboutData,
            pricesTableData: _pricesTableData,
            financingData: _financingData,
            faqQuestions: _faqQuestions
          }));
        case 4:
          _context3.p = 4;
          _t2 = _context3.v;
          console.error("Failed to fetch used cars data:", _t2);
          // fallback: fetch only main data
          _context3.n = 5;
          return api__doSearch_with_params(mainParams);
        case 5:
          return _context3.a(2, _context3.v);
        case 6:
          _context3.n = 7;
          return api__doSearch_with_params(mainParams);
        case 7:
          mainSearchData = _context3.v;
          _getPageDescription3 = getPageDescription(req === null || req === void 0 ? void 0 : req.language, req === null || req === void 0 ? void 0 : req.url, mainSearchData === null || mainSearchData === void 0 ? void 0 : mainSearchData.selectedOptions), pageDescription1 = _getPageDescription3.pageDescription1, pageDescription2 = _getPageDescription3.pageDescription2;
          seoAboutData = getAutosMakeModelAboutData(req === null || req === void 0 ? void 0 : req.url, mainSearchData === null || mainSearchData === void 0 ? void 0 : mainSearchData.selectedOptions);
          pricesTableData = getPricesTableData(mainSearchData === null || mainSearchData === void 0 ? void 0 : mainSearchData.selectedOptions, req === null || req === void 0 ? void 0 : req.language);
          _context3.n = 8;
          return getFinancingData(req, mainSearchData === null || mainSearchData === void 0 ? void 0 : mainSearchData.posts);
        case 8:
          financingData = _context3.v;
          faqQuestions = getFaqQuestions(seoAboutData, mainSearchData === null || mainSearchData === void 0 ? void 0 : mainSearchData.selectedOptions);
          return _context3.a(2, _objectSpread(_objectSpread({}, mainSearchData), {}, {
            pageDescription1: pageDescription1,
            pageDescription2: pageDescription2,
            seoAboutData: seoAboutData,
            pricesTableData: pricesTableData,
            financingData: financingData,
            faqQuestions: faqQuestions
          }));
      }
    }, _callee3, null, [[1, 4]]);
  }));
  return function autosFullPageData(_x4) {
    return _ref8.apply(this, arguments);
  };
}();
export var searchHeaderTags = function searchHeaderTags(_ref9) {
  var _fullPageData$metaDat, _fullPageData$metaDat2, _fullPageData$metaDat3, _fullPageData$metaDat4, _fullPageData$posts$2, _fullPageData$posts$3, _fullPageData$similar3;
  var fullPageData = _ref9.fullPageData,
    req = _ref9.req;
  var path = req === null || req === void 0 ? void 0 : req.path;
  var isAutosScreen = isAutosOrYearsScreen({
    pathname: path
  });
  var isNewCars = isNewCarsPage({
    pathname: path
  });
  var lang = req.language;
  var defaultFiltersPageTitle = lang === "ar" ? DEFAULT_AR_TITLE : DEFAULT_EN_TITLE;
  var defaultFiltersPageOGTitle = lang === "ar" ? DEFAULT_AR_OG_TITLE : DEFAULT_EN_OG_TITLE;
  var defaultFiltersPageOGDESC = lang === "ar" ? DEFAULT_AR_OG_DESC : DEFAULT_EN_OG_DESC;
  var defaultFiltersPageOGIMG = lang === "ar" ? DEFAULT_AR_OG_IMG : DEFAULT_EN_OG_IMG;
  var defaultPageTr = lang === "ar" ? DEFAULT_AR_PAGE : DEFAULT_EN_PAGE;
  var selectedOptions = fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.selectedOptions;
  var page = "".concat(defaultPageTr, " ").concat(req.query.page);
  var title = "".concat((fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$metaDat = fullPageData.metaData) === null || _fullPageData$metaDat === void 0 ? void 0 : (_fullPageData$metaDat2 = _fullPageData$metaDat.seoData) === null || _fullPageData$metaDat2 === void 0 ? void 0 : _fullPageData$metaDat2.title) || defaultFiltersPageTitle, " ").concat(req.query.page > 1 ? "- " + page : "");
  var ogTitle;
  var ogDescription;
  var ogImage;
  var metaTags = ((fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$metaDat3 = fullPageData.metaData) === null || _fullPageData$metaDat3 === void 0 ? void 0 : (_fullPageData$metaDat4 = _fullPageData$metaDat3.seoData) === null || _fullPageData$metaDat4 === void 0 ? void 0 : _fullPageData$metaDat4.meta_desc) || []).map(function (tag) {
    return _objectSpread(_objectSpread({}, tag), {}, {
      content: "".concat(tag.content, " ").concat(req.query.page > 1 ? "," + page : "")
    });
  });
  if (isAutosScreen || isNewCars) {
    var _fullPageData$metaDat5, _fullPageData$metaDat6, _fullPageData$metaDat7, _fullPageData$metaDat8, _fullPageData$metaDat9, _fullPageData$metaDat0, _fullPageData$metaDat1, _fullPageData$metaDat10, _fullPageData$metaDat11;
    ogTitle = fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$metaDat5 = fullPageData.metaData) === null || _fullPageData$metaDat5 === void 0 ? void 0 : (_fullPageData$metaDat6 = _fullPageData$metaDat5.seoData) === null || _fullPageData$metaDat6 === void 0 ? void 0 : (_fullPageData$metaDat7 = _fullPageData$metaDat6.og) === null || _fullPageData$metaDat7 === void 0 ? void 0 : _fullPageData$metaDat7.title;
    ogDescription = fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$metaDat8 = fullPageData.metaData) === null || _fullPageData$metaDat8 === void 0 ? void 0 : (_fullPageData$metaDat9 = _fullPageData$metaDat8.seoData) === null || _fullPageData$metaDat9 === void 0 ? void 0 : (_fullPageData$metaDat0 = _fullPageData$metaDat9.og) === null || _fullPageData$metaDat0 === void 0 ? void 0 : _fullPageData$metaDat0.desc;
    ogImage = fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$metaDat1 = fullPageData.metaData) === null || _fullPageData$metaDat1 === void 0 ? void 0 : (_fullPageData$metaDat10 = _fullPageData$metaDat1.seoData) === null || _fullPageData$metaDat10 === void 0 ? void 0 : (_fullPageData$metaDat11 = _fullPageData$metaDat10.og) === null || _fullPageData$metaDat11 === void 0 ? void 0 : _fullPageData$metaDat11.image;
    // canonical url do not have query string & only display page number if page > 1
  } else {
    ogTitle = defaultFiltersPageOGTitle;
    ogDescription = defaultFiltersPageOGDESC;
    ogImage = defaultFiltersPageOGIMG;
    metaTags.push({
      name: "robots",
      content: "noindex, follow"
    });
  }

  // Preload Marketing Banner

  return {
    title: title,
    noIndexFollow: isNoIndexFollow(req.query, true),
    isPaginated: true,
    metaTags: metaTags,
    openGraphTags: generateOpenGraph(req, ogTitle, ogImage ? ogImage : fullPageData !== null && fullPageData !== void 0 && (_fullPageData$posts$2 = fullPageData.posts[0]) !== null && _fullPageData$posts$2 !== void 0 && _fullPageData$posts$2.image_url ? fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$posts$3 = fullPageData.posts[0]) === null || _fullPageData$posts$3 === void 0 ? void 0 : _fullPageData$posts$3.image_url : fullPageData === null || fullPageData === void 0 ? void 0 : (_fullPageData$similar3 = fullPageData.similarItems[0]) === null || _fullPageData$similar3 === void 0 ? void 0 : _fullPageData$similar3.image_url, ogDescription),
    breadCrumbsDS: generateBreadcrumbMarkup(req, selectedOptions || []),
    carouselListItems: generateCarouselMarkup(req, (fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.posts) || []),
    faqPageDS: generateFAQPageMarkup((fullPageData === null || fullPageData === void 0 ? void 0 : fullPageData.faqQuestions) || [], lang)
  };
};
var generateBreadcrumbMarkup = function generateBreadcrumbMarkup(req, selectedOptions) {
  var isYearsPage = req.url.includes("/years");
  var listItems = [{
    "@type": "ListItem",
    position: 1,
    name: req.language === "ar" ? "الرئيسية" : "Home",
    item: "".concat(serverUrl).concat(req.language === "en" ? "/en" : "")
  }, {
    "@type": "ListItem",
    position: 2,
    name: isYearsPage ? req.language === "ar" ? "السنوات" : "Years" : req.language === "ar" ? "سيارات و مركبات" : "Autos",
    item: isYearsPage ? "".concat(serverUrl, "/years") : "".concat(serverUrl, "/autos")
  }];
  if (isYearsPage) {
    var _selectedOptions$sort;
    selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$sort = selectedOptions.sort(function (a, b) {
      if (a.filterField === "year") {
        return -1;
      } else if (b.filterField === "year") {
        return 1;
      } else {
        return 0;
      }
    })) === null || _selectedOptions$sort === void 0 ? void 0 : _selectedOptions$sort.forEach(function (option, index) {
      if (option.filterField === "make_id" || option.filterField === "year") {
        listItems.push({
          "@type": "ListItem",
          position: index + 3,
          name: option.filterField === "year" && option.range_values.from == option.range_values.to ? option.range_values.from : option.name.toUpperCase(),
          item: createYearsBreadcrumbLink(selectedOptions, option)
        });
      }
    });
  } else {
    selectedOptions.forEach(function (option, index) {
      if (option.filterField === "make_id" || option.filterField === "model_id" || option.filterField === "year") {
        listItems.push({
          "@type": "ListItem",
          position: index + 3,
          name: option.filterField === "year" && option.range_values.from == option.range_values.to ? option.range_values.from : option.name.toUpperCase(),
          item: createBreadcrumbLink(selectedOptions, option)
        });
      }
    });
  }
  return "\n          {\n            \"@context\": \"https://schema.org/\",\n            \"@type\": \"BreadcrumbList\",\n            \"itemListElement\": ".concat(JSON.stringify(listItems), "\n          }\n        ");
};
var createYearsBreadcrumbLink = function createYearsBreadcrumbLink(selectedOptions, option) {
  var _selectedOptions$find, _selectedOptions$find2;
  var year = (_selectedOptions$find = selectedOptions.find(function (item) {
    return item.filterField === "year";
  })) === null || _selectedOptions$find === void 0 ? void 0 : (_selectedOptions$find2 = _selectedOptions$find.range_values) === null || _selectedOptions$find2 === void 0 ? void 0 : _selectedOptions$find2.from;
  if (option.filterField === "year") {
    return "".concat(serverUrl, "/years/").concat(option.range_values.from);
  }
  if (option.filterField === "make_id") {
    return "".concat(serverUrl, "/years/").concat(year, "/").concat(option.name_en);
  }
};
var createBreadcrumbLink = function createBreadcrumbLink(selectedOptions, option) {
  var _selectedOptions$find3, _selectedOptions$find4;
  var makeName = (_selectedOptions$find3 = selectedOptions.find(function (item) {
    return item.filterField === "make_id";
  })) === null || _selectedOptions$find3 === void 0 ? void 0 : _selectedOptions$find3.name_en;
  var modelName = (_selectedOptions$find4 = selectedOptions.find(function (item) {
    return item.filterField === "model_id";
  })) === null || _selectedOptions$find4 === void 0 ? void 0 : _selectedOptions$find4.name_en;
  if (option.filterField === "make_id") {
    return "".concat(serverUrl, "/autos/").concat(option.name_en);
  }
  if (option.filterField === "model_id") {
    return "".concat(serverUrl, "/autos/").concat(makeName, "/").concat(option.name_en);
  }
  if (option.filterField === "year") {
    return "".concat(serverUrl, "/autos/").concat(makeName, "/").concat(modelName, "/").concat(option.range_values.from);
  }
};
export var generateCarouselMarkup = function generateCarouselMarkup(req, posts) {
  if ((posts === null || posts === void 0 ? void 0 : posts.length) === 0) return "";
  var thePosts = posts.filter(function (post) {
    return !post.isEligibilityCard;
  });
  var isEn = req.language === "en";
  var itemListElement = thePosts.map(function (post, index) {
    var _post$g4_data_layer;
    return {
      "@type": "ListItem",
      position: index + 1,
      item: _objectSpread(_objectSpread({
        "@type": "Product",
        name: post.title,
        url: post.product_url,
        image: post === null || post === void 0 ? void 0 : post.image_url,
        description: isEn ? "".concat(post.title, " in Saudi Arabia at the best price with comprehensive warranty from Syarah, buy the car online now while you're in your place.") : "\u0633\u064A\u0627\u0631\u0629 ".concat(post.title, " \u0627\u0644\u0645\u0645\u064A\u0632\u0629 \u0645\u0646 \u0645\u0648\u0642\u0639 \u0633\u064A\u0627\u0631\u0629 \u0641\u064A \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629 \u0628\u0623\u0641\u0636\u0644 \u0633\u0639\u0631 \u0645\u0639 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0634\u0627\u0645\u0644, \u0627\u0634\u062A\u0631 \u0627\u0644\u0633\u064A\u0627\u0631\u0629 \u0627\u0648\u0646\u0644\u0627\u064A\u0646 \u0627\u0644\u0622\u0646 \u0648\u0627\u0646\u062A \u0645\u0643\u0627\u0646\u0643")
      }, !post.product_url ? {} : {
        url: post === null || post === void 0 ? void 0 : post.product_url
      }), {}, {
        offers: _objectSpread({
          "@type": "Offer",
          priceCurrency: "SAR",
          price: normalizePrice(post === null || post === void 0 ? void 0 : post.sellingprice),
          priceValidUntil: getDateThreeMonthsFromNow(),
          availability: "https://schema.org/InStock"
        }, !(post !== null && post !== void 0 && (_post$g4_data_layer = post.g4_data_layer) !== null && _post$g4_data_layer !== void 0 && _post$g4_data_layer.post_condition) ? {} : {
          itemCondition: "https://schema.org/".concat(post.g4_data_layer.post_condition, "Condition")
        })
      })
    };
  });
  return "\n          {\n            \"@context\": \"https://schema.org/\",\n            \"@type\": \"ItemList\",\n            \"itemListElement\": ".concat(JSON.stringify(itemListElement), "\n          }\n        ");
};

/**
 * Generates FAQPage schema markup (JSON-LD) for SEO
 * Following Google's official FAQPage structured data guidelines
 * @see https://developers.google.com/search/docs/appearance/structured-data/faqpage
 */
export var generateFAQPageMarkup = function generateFAQPageMarkup(faqQuestions, language) {
  // Return empty string if no FAQ questions
  if (!faqQuestions || faqQuestions.length === 0) {
    return "";
  }
  var isArabic = language === "ar";
  var mainEntity = faqQuestions.map(function (faq) {
    return {
      "@type": "Question",
      "name": isArabic ? faq.question_ar : faq.question_en,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": isArabic ? faq.answer_ar : faq.answer_en
      }
    };
  });
  return JSON.stringify({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": mainEntity
  });
};
var generateOpenGraph = function generateOpenGraph(req, title, image, description) {
  return [{
    propertyName: "property",
    propertyContent: "og:title",
    content: title
  }, {
    propertyName: "property",
    propertyContent: "og:type",
    content: "website"
  }, {
    propertyName: "property",
    propertyContent: "og:url",
    content: serverUrl + req.url
  }, {
    propertyName: "property",
    propertyContent: "og:image",
    content: image
  }, {
    propertyName: "property",
    propertyContent: "og:description",
    content: description
  }];
};